<template>
    <div class="appWrapper">
    <div class="holder">
        <div class="thankyouWrapper">
            <h3 >Thank you for attending </h3>
            <h2 >{{ $route.params.name }} </h2>
            <p>We hope you enjoy the day!.</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
    return {

    };
  }
};
</script>

<style>

</style>